import DelaysPareto from "@/pages/delays/delays-pareto";
import { Suspense } from "react";
import { Route } from "react-router-dom";
import { LazyLoading } from "../../controls/LazyLoading";
import DelaysManager from "../../pages/delays/delays-manager";
import DelaysReport from "../../pages/delays/delays-report";

export const DelaysRoutes = [
	<Route
		path="/caster-delays-manager"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<DelaysManager asset="caster" />
			</Suspense>
		}
	/>,
	<Route
		path="/caster-delays-manager/:shiftId"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<DelaysManager asset="caster" />
			</Suspense>
		}
	>
		{" "}
	</Route>,
	<Route
		path="/eaf-delays-manager"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<DelaysManager asset="eaf" />
			</Suspense>
		}
	/>,
	<Route
		path="/eaf-delays-manager/:shiftId"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<DelaysManager asset="eaf" />
			</Suspense>
		}
	>
		{" "}
	</Route>,
	<Route
		path="/caster-delays-report"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<DelaysReport asset="caster" />
			</Suspense>
		}
	/>,
	<Route
		path="/caster-delays-report/:shiftId"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<DelaysReport asset="caster" />
			</Suspense>
		}
	/>,
	<Route
		path="/eaf-delays-report"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<DelaysReport asset="eaf" />
			</Suspense>
		}
	/>,
	<Route
		path="/eaf-delays-report/:shiftId"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<DelaysReport asset="eaf" />
			</Suspense>
		}
	/>,
	<Route
		path="/caster-delays-pareto"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<DelaysPareto asset="caster" />
			</Suspense>
		}
	/>,
	<Route
		path="/caster-delays-pareto/:shiftId"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<DelaysPareto asset="caster" />
			</Suspense>
		}
	/>,
	<Route
		path="/eaf-delays-pareto"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<DelaysPareto asset="eaf" />
			</Suspense>
		}
	/>,
	<Route
		path="/eaf-delays-pareto/:shiftId"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<DelaysPareto asset="eaf" />
			</Suspense>
		}
	/>,
];
